import React from 'react';

import { fetchGroupCourseListFlow } from 'reduxModules/course/saga';
import {
  fetchGroupCourseList,
  updateCourseSelectedGradeLevel,
} from 'reduxModules/course/action';
import { getCourseGroupInfo } from 'reduxModules/course/selector';
import Layout from 'components/Layout';
import SnapaskHeader from 'components/SnapaskHeader';
import AlertBanner from 'components/AlertBanner/AlertBanner';
import SnapaskLocaleSelection from 'components/SnapaskLocaleSelection';
import SocialWidgetHandler from 'components/SocialWidgetHandler/SocialWidgetHandler';
import SnapaskFooter from 'components/SnapaskFooter';

import CourseGroup from './CourseGroup';

async function action(context, params) {
  const {
    store,
    i18n,
    query: { subjectId, gradeLevelId },
  } = context;
  const tempSubjectId = parseInt(subjectId, 10);
  const tempGradeLevelId = parseInt(gradeLevelId, 10);
  store.dispatch(
    updateCourseSelectedGradeLevel({
      selectedGradeLevel: tempGradeLevelId || 0,
      selectedSubject: tempSubjectId || 0,
    }),
  );
  const { id, currentPage } = store.getState(getCourseGroupInfo);

  const payload = {
    groupId: id || Number(params.id),
    currentPage: currentPage || 1,
  };

  await Promise.all([
    store
      .runSagas(fetchGroupCourseListFlow, fetchGroupCourseList(payload))
      .toPromise(),
  ]);

  return {
    title: i18n.t('seo:seo.courses.title'),
    description: i18n.t('seo:seo.courses.desc'),
    chunks: ['courseGroup'],
    component: (
      <Layout>
        <SnapaskHeader />
        <AlertBanner />
        <SnapaskLocaleSelection />
        <SocialWidgetHandler />
        <CourseGroup />
        <SnapaskFooter />
      </Layout>
    ),
  };
}

export default action;
